import { render, staticRenderFns } from "./avalonBlockContainer.vue?vue&type=template&id=068dd281&scoped=true&"
import script from "./avalonBlockContainer.vue?vue&type=script&lang=js&"
export * from "./avalonBlockContainer.vue?vue&type=script&lang=js&"
import style0 from "./avalonBlockContainer.vue?vue&type=style&index=0&id=068dd281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068dd281",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VBtnToggle,VCol,VFadeTransition,VIcon,VRow,VSheet})
